import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Dialog, IconButton } from 'react-toolbox';
import { connect } from 'react-redux';
import InstallationCompletion from 'cocSignature/installation_completion';
import CustomerSignature from 'cocSignature/customer_signature';
import SurplusMaterial from 'cocSignature/surplus_material';
import ContractorConfirmation from 'cocSignature/contractor_confirmation';
import ContractorSignature from 'cocSignature/contractor_signature';
import S from 'modal.scss';
import Loading from 'components/Loading';
import styles from 'styles/input.scss';
import { clearValidation, cocCreate, updatePhaseTask } from 'actionCreators';
import PhaseType from 'types/phase';

class CocModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    customerSignature: '',
    customerName: '',
    surplusMaterials: 'opt1',
    customerInitials: '',
    approveTerms: '',
    contractorSignature: '',
    contractorName: '',
    errors: {},
    tab: 1,
  }

  static VALIDATIONS = {
    signature: true,
    name: true,
  }

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
    document.location.reload();
  }

  updateFormData = (cocData) => {
    this.setState(cocData, () => {
      if (cocData.tab === 6) {
        this.props.cocCreate({
          contractor_name: this.state.contractorName,
          contractor_signature: this.state.contractorSignature,
          customer_initials: this.state.customerInitials,
          customer_name: this.state.customerName,
          customer_signature: this.state.customerSignature,
          surplus_materials: this.state.surplusMaterials,
          phase_id: this.props.phase.id,
        }).then(() => {
          this.handleClose();
        }).catch(() => { });
      }
    });
  }

  showTab = () => {
    switch (this.state.tab) {
      case 1:
        return (<InstallationCompletion
          phase={this.props.phase}
          updateFormData={this.updateFormData}
          customerName={this.state.customerName}
        />);
      case 2:
        return (<CustomerSignature
          phase={this.props.phase}
          updateFormData={this.updateFormData}
          customerSignature={this.state.customerSignature}
        />);
      case 3:
        return (<SurplusMaterial
          phase={this.props.phase}
          updateFormData={this.updateFormData}
          surplusMaterials={this.state.surplusMaterials}
          customerInitials={this.state.customerInitials}
        />);
      case 4:
        return (<ContractorConfirmation
          updateFormData={this.updateFormData}
          approveTerms={this.state.approveTerms}
          contractorName={this.state.contractorName}
        />);
      case 5:
        return (<ContractorSignature
          updateFormData={this.updateFormData}
          contractorSignature={this.state.contractorSignature}
        />);
      default:
        return (<Loading />);
    }
  }

  render() {
    const { active, errors: serverErrors } = this.props;
    return (
      <Dialog
        active={active} className={S.modal} type="fullscreen"
        onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
      >
        <div className={styles.errored}>
          {Object.keys(serverErrors).length > 0 &&
            <span className={styles.error}>This action could not be completed.</span>}
        </div>

        <IconButton icon="close" className={S.close} onClick={this.handleClose} />
        <h5>Sign Certificate of Completion</h5>
        {this.showTab()}
      </Dialog>
    );
  }
}

CocModal.propTypes = {
  active: PropTypes.bool.isRequired,
  clearValidation: PropTypes.func.isRequired,
  cocCreate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    signature: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.arrayOf(PropTypes.string),
  }),
};

CocModal.defaultProps = {
  active: false,
};

export default connect(state => ({ errors: state.cocs.uploadError }), {
  clearValidation,
  cocCreate,
  updatePhaseTask,
})(CocModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/cocModal.jsx